<div class="background"></div>
<app-header></app-header>
@if (clinicName && siteConfig) {
<header><b>{{clinicName}}</b> at <b>{{siteConfig.organisationName}}'s</b> </header>
}
<app-loading></app-loading>

        <div class="container" >
            <router-outlet></router-outlet>
        </div>

<app-footer></app-footer>

<app-snackbar></app-snackbar>